import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {MomentTransformer} from '../helpers/moment-transformer';
import * as moment from 'moment';
import {OnboardingStep} from './onboarding-step';
import {OnboardingStepTransformer} from '../helpers/enum/onboarding-step-transformer';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class BijbEvent extends ModelBase {
  public static readonly type = 'Event';
  public readonly type = BijbEvent.type;

  @autoserialize
  public id: number;

  @autoserialize
  public naam: string;

  @autoserializeAs('is_demo')
  public isDemo: boolean;

  @autoserializeAs('payment_failed')
  public betalingMislukt: boolean;

  @autoserializeAs(MomentTransformer, 'datum_van_event')
  public datumVanEvent: moment.Moment;

  @autoserializeAs(MomentTransformer, 'deadlineRSVP')
  public deadlineRSVP: moment.Moment;

  @autoserializeAs('giphy_url')
  public giphyUrl: string;

  @autoserializeAs('giphy_text')
  public giphyText: string;

  @autoserializeAs('slideshow_url')
  public slideshowUrl: string;

  @autoserializeAs('slideshow_password')
  public slideshowPassword: string;

  @autoserializeAs('registration_text')
  public registrationText: string;

  @autoserializeAs(OnboardingStepTransformer, 'onboarding_step')
  public onboardingStep: OnboardingStep;

  public paid(): boolean {
    return !this.isDemo;
  }
}
